import { Text } from "@mantine/core";
import { IconSend } from "@tabler/icons-react";
import "./EmailSent.scss";

const EmailSent = () => {
  return (
    <div className="email-sent-container">
      <div className="send-icon">
        <IconSend size={25} />
      </div>
      <Text>Email Sent</Text>
    </div>
  );
};

export default EmailSent;
